import { request } from './client';

export type CommentReplyDecision = 'REPLY' | 'IGNORE' | 'HIDE_POST' | 'PIN';
export type CommentReplyStatus =
  | 'REVIEW_REQUIRED'
  | 'CANCELLED'
  | 'SCHEDULED'
  | 'REPLIED'
  | 'IGNORED'
  | 'HIDDEN'
  | 'POST_HIDDEN'
  | 'PINNED'
  | 'FAILED';

export interface ThreadCommentReply {
  id: number;
  threadAccountId: number;
  threadAccountPostId?: number | null;
  rootThreadPostId: string;
  commentMediaId: string;
  commentUsername?: string | null;
  commentText?: string | null;
  commentTimestamp?: string | null;
  decision: CommentReplyDecision;
  decisionReason?: string | null;
  replyText?: string | null;
  replyMediaId?: string | null;
  status: CommentReplyStatus;
  errorMessage?: string | null;
  createdAt?: string | null;
}

export function listCommentReplies(threadAccountId: number) {
  return request<ThreadCommentReply[]>(
    `/api/thread-comment-replies/thread-account/${threadAccountId}`,
    { method: 'GET' }
  );
}
